import React from 'react';
import { Link as OgLink } from 'gatsby';
import { MenuItemsQuery } from './MenuItemsQuery';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';
import { HiMenu, HiChevronDown } from 'react-icons/hi';
import { SiBluesky } from 'react-icons/si';
import {
  Link,
  useI18next,
  I18nextContext,
  useTranslation,
} from '@herob191/gatsby-plugin-react-i18next';

function slugify(string) {
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

export const MenuComponents = () => {
  const menuItems = MenuItemsQuery();
  const { languages, originalPath } = useI18next();
  const context = React.useContext(I18nextContext);
  const { t } = useTranslation();

  const topicItems = menuItems.allTopics.edges;

  topicItems.sort(
    (a, b) => a.node.frontmatter.order - b.node.frontmatter.order
  );

  return (
    <>
      <Menu as="div">
        <MenuButton className="navbar-item nav-link">
          {t('common:menu.topics')}
          <HiChevronDown className="-mt-1 ml-1 inline-block h-4 w-4 fill-white" />
        </MenuButton>
        <MenuItems className="menu-items absolute mt-2 bg-stone-900 p-4">
          {topicItems.map(
            (topic) =>
              topic.node.frontmatter.active &&
              topic.node.fields.language === context.language && (
                <OgLink
                  to={topic.node.fields.slug}
                  className="navbar-item sub-nav-link"
                >
                  {topic.node.frontmatter.title}
                </OgLink>
              )
          )}
          <div className="my-2 h-0.5 w-full bg-white"></div>
          <OgLink to="/previous-topics" className="navbar-item sub-nav-link">
            Previous Topics
          </OgLink>

          {/* {topicItems.map(
            (topic) =>
              !topic.node.frontmatter.active &&
              topic.node.fields.language === context.language && (
                <MenuItem>
                  <OgLink
                    to={topic.node.fields.slug}
                    className="navbar-item sub-nav-link"
                  >
                    {topic.node.frontmatter.title}
                  </OgLink>
                </MenuItem>
              )
          )} */}
        </MenuItems>
      </Menu>
      <Menu as="div">
        <MenuButton className="navbar-item nav-link">
          {t('common:menu.formats')}
          <HiChevronDown className="-mt-1 ml-1 inline-block h-4 w-4 fill-white" />
        </MenuButton>
        <MenuItems className="menu-items absolute mt-2 bg-stone-900 p-4">
          {menuItems.allFormats.edges.map(
            (format) =>
              format.node.fields.language === context.language && (
                <MenuItem>
                  <OgLink
                    to={format.node.fields.slug}
                    className="navbar-item sub-nav-link"
                  >
                    {format.node.frontmatter.title}
                  </OgLink>
                </MenuItem>
              )
          )}
        </MenuItems>
      </Menu>
      <Link
        className="navbar-item nav-link"
        to="/about"
        language={context.language}
      >
        {t('common:menu.about')}
      </Link>
      <ul className="languages flex items-center space-x-2 rounded-xs border-l-2 border-stone-800 pl-4">
        {languages.map((lng) =>
          lng === context.language ? (
            <li
              key={lng}
              className="navbar-item nav-link text-gecko-red inline-block"
            >
              <Link to={originalPath} language={lng} className="">
                {lng}
              </Link>
            </li>
          ) : (
            <li key={lng} className="navbar-item nav-link inline-block">
              <Link to={originalPath} language={lng} className="">
                {lng}
              </Link>
            </li>
          )
        )}
      </ul>
      <a
        className="navbar-item nav-link hover:border-none"
        href="https://bsky.app/profile/thegeckoproject.org"
      >
        <SiBluesky className="hover:fill-gecko-red ml-4 h-4 w-4" />
      </a>
    </>
  );
};

export const MenuItemsBurger = () => {
  const menuItems = MenuItemsQuery();
  const context = React.useContext(I18nextContext);
  const { t } = useTranslation();
  const { languages, originalPath } = useI18next();

  return (
    <>
      <ul className="languages block items-center space-x-2 rounded-xs border-r-2 border-stone-800 pr-4">
        {languages.map((lng) =>
          lng === context.language ? (
            <li
              key={lng}
              className="navbar-item nav-link text-gecko-red inline-block"
            >
              <Link to={originalPath} language={lng} className="">
                {lng}
              </Link>
            </li>
          ) : (
            <li key={lng} className="navbar-item nav-link inline-block">
              <Link to={originalPath} language={lng} className="">
                {lng}
              </Link>
            </li>
          )
        )}
      </ul>
      <Menu as="div" className="h-8">
        <MenuButton className="">
          <HiMenu
            className="hover:fill-gecko-red -mr-1 ml-2 h-8 w-8 fill-white"
            aria-hidden="true"
          />
        </MenuButton>

        <MenuItems className="menu-items absolute right-2 mt-2 bg-stone-900 p-4">
          <MenuItem
            as="String"
            className="navbar-item nav-link border-b-gecko-red py-2"
          >
            {t('common:menu.topics')}
          </MenuItem>
          {menuItems.allTopics.edges.map(
            (topic) =>
              topic.node.frontmatter.active &&
              topic.node.fields.language === context.language && (
                <MenuItem>
                  <OgLink
                    to={topic.node.fields.slug}
                    className="navbar-item sub-nav-link"
                  >
                    {topic.node.frontmatter.title}
                  </OgLink>
                </MenuItem>
              )
          )}
          <div className="my-2 h-0.5 w-full bg-white"></div>
          <OgLink to="/previous-topics" className="navbar-item sub-nav-link">
            {t('homepage:sectionTitles.topics')}
          </OgLink>
          <MenuItem
            as="String"
            className="navbar-item nav-link border-b-gecko-red py-2"
          >
            {t('common:menu.formats')}
          </MenuItem>
          {menuItems.allFormats.edges.map(
            (format) =>
              format.node.fields.language === context.language && (
                <Menu.Item>
                  <OgLink
                    to={format.node.fields.slug}
                    className="navbar-item sub-nav-link"
                  >
                    {format.node.frontmatter.title}
                  </OgLink>
                </Menu.Item>
              )
          )}
          <MenuItem
            as="String"
            className="navbar-item nav-link border-b-gecko-red py-2"
          >
            <Link to="/about">{t('common:menu.about')}</Link>
          </MenuItem>
        </MenuItems>
      </Menu>
    </>
  );
};

// export default MenuItemsBurger;

export const FooterMenu = () => {
  const menuItems = MenuItemsQuery();
  const context = React.useContext(I18nextContext);
  const { t } = useTranslation();

  return (
    <>
      <ul className="col-span-full px-0 pt-4 md:col-span-2 md:px-4 md:pt-0">
        <li className="navbar-item nav-link border-b-gecko-red pb-2">
          {t('common:menu.topics')}
        </li>
        {menuItems.allTopics.edges.map(
          (topic) =>
            topic.node.frontmatter.active &&
            topic.node.fields.language === context.language && (
              <li>
                <OgLink
                  to={topic.node.fields.slug}
                  className="navbar-item sub-nav-link"
                >
                  {topic.node.frontmatter.title}
                </OgLink>
              </li>
            )
        )}
        <div className="my-2 h-0.5 w-full bg-white"></div>
        <OgLink to="/previous-topics" className="navbar-item sub-nav-link">
          {t('homepage:sectionTitles.topics')}
        </OgLink>
        {/* {menuItems.allTopics.edges.map(
          (topic) =>
            topic.node.fields.language === context.language && (
              <li>
                <OgLink
                  to={topic.node.fields.slug}
                  className="navbar-item sub-nav-link"
                >
                  {topic.node.frontmatter.title}
                </OgLink>
              </li>
            )
        )} */}
      </ul>
      <ul className="col-span-full px-0 pt-4 md:col-span-2 md:px-4 md:pt-0">
        <li className="navbar-item nav-link border-b-gecko-red pb-2">
          {t('common:menu.formats')}
        </li>
        {menuItems.allFormats.edges.map(
          (format) =>
            format.node.fields.language === context.language && (
              <li>
                <OgLink
                  to={format.node.fields.slug}
                  className="navbar-item sub-nav-link"
                >
                  {format.node.frontmatter.title}
                </OgLink>
              </li>
            )
        )}
      </ul>
      <ul className="col-span-full px-0 pt-4 md:col-span-2 md:px-4 md:pt-0">
        <li className="navbar-item nav-link border-b-gecko-red pb-2">
          The Gecko Project
        </li>
        <li>
          <OgLink to="/about" className="navbar-item sub-nav-link">
            {t('common:menu.about')}
          </OgLink>
        </li>
        <li>
          <OgLink
            to={`/about/#${slugify(t('common:menu.contact'))}`}
            className="navbar-item sub-nav-link"
          >
            {t('common:menu.contact')}
          </OgLink>
        </li>
      </ul>
    </>
  );
};
